export default __webpack_public_path__ + "static/web_banner_final-fcfc4d97f451348eedd916b9859ac9f9.gif";